import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: '#FFFFFF !important',
  },

  tableCell: {},

  tableSortCell: {
    fontFamily: 'Nunito',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '24px',
    backgroundColor: '#FFFFFF',
  },

  rowTableIcon: {
    color: theme.palette.primary.main,
  },
}))

export { useStyles }
